import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight, ShieldCheck, MapPin } from "lucide-react";
import { BUSINESS, telLink, whatsappLink, IMAGES } from "@/data/business";
import { btnPrimary, btnOutlineNavy, container } from "@/lib/ui";
import { StarRating } from "@/components/StarRating";

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-white" data-testid="hero">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-neutralbg/60 hidden lg:block" />
      <div className={`${container} relative grid lg:grid-cols-2 gap-12 lg:gap-8 items-center pt-14 pb-20 lg:py-24`}>
        {/* Left */}
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-brandgreen/10 px-4 py-1.5 text-sm font-semibold text-brandgreen-dark">
            <MapPin className="w-4 h-4" /> Residential Cleaning · Melbourne
          </span>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-navy">
            Professional House Cleaning <span className="text-brandgreen">You Can Trust</span>
          </h1>
          <p className="mt-6 text-base lg:text-lg text-gray-600 leading-relaxed max-w-xl">
            Enjoy a cleaner, fresher home without the stress. {BUSINESS.name} provides professional
            house cleaning across West Melbourne, East Melbourne and North Melbourne.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-4">
            <Link to="/quote" className={btnPrimary} data-testid="hero-quote">
              Get a Free Quote <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={telLink} className={btnOutlineNavy} data-testid="hero-call">
              <Phone className="w-4 h-4" /> Call {BUSINESS.phoneDisplay}
            </a>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 font-semibold text-brandgreen-dark hover:text-brandgreen transition-colors"
              data-testid="hero-whatsapp"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3">
            <div className="flex items-center gap-3">
              <StarRating value={5} />
              <span className="text-sm text-gray-600">
                Loved by Melbourne locals
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <ShieldCheck className="w-4 h-4 text-brandgreen" /> ABN Registered · Insured · Police Checked
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="relative fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative rounded-3xl overflow-hidden shadow-[0_24px_60px_rgba(15,61,94,0.18)] max-h-[540px]">
            <img
              src={IMAGES.heroLiving}
              alt="Bright, freshly cleaned Melbourne living room"
              className="w-full h-full object-cover"
              fetchPriority="high"
            />
          </div>
          <div className="absolute -bottom-5 -left-4 sm:left-6 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3 border border-gray-100">
            <span className="grid place-items-center w-11 h-11 rounded-xl bg-brandgreen/10">
              <ShieldCheck className="w-6 h-6 text-brandgreen" />
            </span>
            <div>
              <p className="font-heading font-bold text-navy leading-tight">Fully Insured</p>
              <p className="text-xs text-gray-500">Public Liability cover</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
